export { default } from "./Card16x9"
